const layoutConstants = {
  event: {
    LAYOUT_CLICK: 'layout.click'
  },
  views: {
    side: {
      menu: {
        expandTop: true,
        threshold: 4
      }
    }
  },
  template: {
    grid: {
      search: {
        keyMode: true,
        history: {
          remote: false
        }
      },
      column: {
        visible: {
          remote: false
        },
        fixed: {
          remote: false
        },
        order: {
          remote: false
        }
      }
    }
  }
}

export default layoutConstants
